import AgeDistributionChart from "../../components/charts/AgeDistributionCharts";

export default function Demographics() {
  return (
    <div className="bg-white rounded-xl shadow-sm p-12 w-full overflow-x-auto">
      <div className="card px-12">
        <h1 className="font-bold text-2xl">Age Distribution</h1>
        {/* <p className="subtitle">Mean age: 26.7 years</p> */}

        <AgeDistributionChart />
      </div>
    </div>
  );
}
